import React, { Component } from 'react';
import "./style.css"
import { Hcurl } from "./../../../constants/index"//获取公共路径
import EventSet from "./../../../assets/PubJs/hcPub"//公用的所有事件
import $ from "jquery"
import createHistory from 'history/createHashHistory';//路由切换地址
const history = createHistory();//定义history路由
class App extends Component {
    state = {
        num: 0
    }
    toCompromise() {
        history.push({ "pathname": "/Content/Business/CompromiseListWait" })
    }
    toCollection() {
        history.push({ "pathname": "/Content/Business/RepaymentCenter" })
    }
    
    componentDidMount() {
        let _this = this;
        $.ajax({
            url: Hcurl + "/HomePage/GetDepartmentUserWorkItemInfo?UserCode=" + EventSet.getUserInfo().CU_Code+"&comCode=" + EventSet.getUserInfo().xxhjcompanycode,
            type: "get",
            headers: {
                "token": EventSet.getUserInfo()['token']
            },
            async: false,
            success: function (res) {
                console.log('25',res)
                _this.setState({
                    num:res[0]
                })
                localStorage.setItem('homeData',JSON.stringify(res[0]))
            },
            error: function () {
                history.push({ "pathname": "/Login/LoginMain/LoginEntry" })
            }
        })
    }
    render() {
        return (
            <div style={{ position: "relative" }} className={"Crumb"}>
                <span>{this.props.title}</span>
                <div onClick={this.toCollection} style={{float:'right', height:'30px',lineHeight:'30px', cursor: "pointer",background:'#f5f5f5',padding:'0 8px', border:'1px solid #d9d9d9',boxSizing:'border-box',borderRadius:'4px',marginTop:'15px',marginRight:'24px'}}> 待还款 （{this.state.num.dhkCount}）</div>
                <div onClick={this.toCompromise} style={{float:'right', height:'30px',lineHeight:'30px', cursor: "pointer",background:'#f5f5f5',padding:'0 8px', border:'1px solid #d9d9d9',boxSizing:'border-box',borderRadius:'4px',marginTop:'15px',marginRight:'24px'}}> 待和解 （{this.state.num.dhjCount}）</div>
            </div>
        );
    }
}
export default App


// WEBPACK FOOTER //
// ./src/components/Content/Crumbs/Crumb.js